import { Capacitor } from '@capacitor/core';
import { FirebaseAnalytics } from '@capacitor-firebase/analytics';
import posthog from 'posthog-js';
import { func } from 'utils';

export enum eventTypes {
	APP_LAUNCH = 'app_launch',
	ORDER_CANCEL = 'order_cancel',
	BEGIN_CHECKOUT = 'begin_checkout',
	ADD_TO_CART = 'add_to_cart',
	PURCHASE_COMPLETE = 'purchase_complete',
	VIEW_ITEM = 'view_item',
	SIGN_IN = 'sign_in',
	SIGN_UP = 'sign_up',
	ACTIVATION = 'activation',
	VIEW_STORE = 'view_store',
	VIEW_CART = 'view_cart',
	PAGE_VIEW = 'page_view',
	ORDER_PLACED = 'order_placed',
	VERIFIED_EMAIL = 'verified_email',
	VERIFIED_PHONE = 'verified_phone',
}

export const trackEvent = async (name: eventTypes, params?: object) => {
	posthog.capture(name, params);
	if (Capacitor.isNativePlatform()) {
		!func.isStagingOrLocal &&
			(await FirebaseAnalytics.logEvent({ name, params }));
	} else if (window?.gtag) {
		window.gtag('event', name, params);
	}
};
